import {Cookies} from '../shared/cookies-extended';

function initGaTrackerComponent(app) {
    const gaEventTracker = {
        props: {
            category: {},
            action: {},
            label: {},
            value: {},
            isNeedToTrack: {},
            isConversion: {},
        },
        watch: {
            isNeedToTrack: {
                handler(newVal, oldVal) {
                    if (newVal && newVal !== oldVal) {
                        this._trackEvent();
                    }
                },

                immediate: true,
            },
        },
        methods: {
            _trackEvent() {
                const gaTrack = window.ga;
                const defaultEventValue = 1;
                const value = this.value || defaultEventValue;
                if (gaTrack) {
                    gaTrack('send', {
                        hitType: 'event',
                        eventCategory: this.category,
                        eventAction: this.action,
                        eventLabel: this.label,
                        eventValue: value,
                    });
                }

                if (this.isConversion) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'Conversion',
                        category: this.category,
                        action: this.action,
                        label: this.label,
                        value: value,
                    });
                }
            },
        },
        render() {
            return null;
        },
    };


    app.component('ga-event-track', {extends: gaEventTracker});

    app.component('ga-event-track-cookie-state', {
        extends: gaEventTracker,
        props: {
            cookieName: {type: String},
            cookieValue: {type: String},
        },
        watch: {
            cookieValue: {
                handler(val) {
                    if (JSON.parse(val) === true) {
                        const that = this;
                        this._readCookieValue().then((oldValue) => {
                            if (val !== oldValue) {
                                that._trackEvent();
                                that._setCookieValue().then(that._onCookiesSet).catch(that._onCookiesSet);
                            }
                        });
                    }
                },
                immediate: true,
            },
        },

        methods: {
            _onCookiesSet() {
                // no actions required
            },

            _readCookieValue() {
                return Cookies.getWithBackupCheckAsync(this.cookieName);
            },

            _setCookieValue() {
                const extraLongExpiration = 365000;
                return Cookies.setWithBackupAsync(this.cookieName, `${this.cookieValue}`, {expires: extraLongExpiration});
            },
        },
    });
}

export default initGaTrackerComponent;
